class ScrollElements{

	inViewport(element){
		  var rect = element.getBoundingClientRect();
		  var html = document.documentElement;

		  return (
		  	(rect.top < (window.innerHeight || html.clientHeight) * 0.9) ||
		  	(window.innerHeight + window.scrollY) >= document.body.offsetHeight
		  );
	}

	scrollFunc(){

		var scrollY = window.pageYOffset;
	
		for(var i = 0; i < this.$elements.length; i++){
			var $el = this.$elements[i];
			if(!$el.classList.contains('scrolled') && this.inViewport($el))
				$el.classList.add('scrolled');

		}

	}

	constructor() {

		this.$elements = document.getElementsByClassName('scroll-el');
		this.scrollFunc = this.scrollFunc.bind(this);
		window.addEventListener('scroll', this.scrollFunc);
		this.scrollFunc();

	}


}

module.exports = new ScrollElements;


/** WEBPACK FOOTER **
 ** ./components/scrollElements.js
 **/